var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTmLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 24,
    viewBox: "0 0 313 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28.9689L26.3899 4.37492H16.3025V23.8415H11.3736V4.37492H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.538 23.8611H157.466V0.0131384H152.538V23.8611Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5832 0.019756L73.4238 23.8611H79.0718L81.7078 19.3745H98.6531L101.289 23.8611H106.933L92.7798 0.019756H87.5832ZM84.2824 15.0044L90.1797 5.02664L96.0784 15.0044H84.2824Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.115 0.0166252H183.52L166.006 11.9236L183.569 23.8643H175.164L157.602 11.9236L175.115 0.0166252Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.188 0.0131384L211.725 17.8932L199.266 0.0131384H192.88V23.8611H197.815V6.34048L209.964 23.8611H213.493L225.638 6.34048V23.8611H230.569V0.0131384H224.188Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.992 19.3745L245.348 23.8678H239.708L253.865 0.0197649H259.061L273.221 23.8678H267.578L264.937 19.3745H247.992ZM262.359 15.0044L256.464 5.02664L250.563 15.0044H262.359Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M307.568 0.0197649V18.2417L288.571 0.0197649H282.423V23.8678H287.359V5.63359L306.361 23.8678H312.5V0.0197649H307.568Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.325 16.5435C136.814 18.2833 135.212 19.5191 133.41 19.5191L122.793 19.5138C120.837 19.5138 119.153 18.3043 118.789 16.1964C118.292 13.2974 118.242 10.4915 118.763 7.79758C119.173 5.68304 120.83 4.31579 122.793 4.31579C124.758 4.31579 133.41 4.32758 133.41 4.32758C135.242 4.32758 136.827 5.5363 137.326 7.2704L141.512 4.42181C140.33 2.08727 137.799 0 134.169 0H121.892C117.903 0 115.038 2.8257 114.111 5.90529C113.144 9.11748 113.184 14.7839 114.082 17.8376C115.044 21.1099 117.794 23.8415 121.892 23.8415H134.163C137.828 23.8415 140.336 21.741 141.519 19.3965L137.325 16.5435Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1492 0.019756C62.2818 0.019756 65.6431 3.42918 65.6431 8.11744C65.6431 11.6541 63.6176 14.5377 60.7801 15.6692L65.6431 23.8611H60.014L55.4948 16.1754H43.1177V23.8415H38.1897V0.019756H58.1492ZM43.1177 11.9288H57.4569C59.4982 11.9288 61.1459 10.2899 61.2082 8.11744C61.1459 5.95915 59.4982 4.30481 57.4569 4.30481H43.1177V11.9288Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTmLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TM-logo.6203948aafde86e78fee6429edcef64a.svg";